import React from "react";
import { NodeProps, useReactFlow } from "reactflow";
import { operationType } from "../../../../../services/types";
import { SettingsBlock, settingsDataType } from "../../../../settingsBlock";
import { ExpandedBlock } from "../../../expanded";
import { updateNodeValue } from "../../../../../services/method";
import { Main, Styled } from "./style";
import { TextInput } from "../../../../form/textInput";
import { Textarea } from "../../../../form/textarea";
import { IoCheckmarkCircleOutline, IoWarningOutline } from "react-icons/io5";
import { AuthenticateSelect } from "../../../../auth/select";

type InstagramSendMessageProps = NodeProps<operationType> & {
  setChildMinimize?: (fn: (id: string) => void) => void;
  setChildSettings?: (fn: (id: string) => void) => void;
};

export function InstagramSendMessage({
    id,
  data,
  setChildMinimize,
  setChildSettings,
}: InstagramSendMessageProps) {
  const { setNodes } = useReactFlow();
  const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
  const [isExpanded, setIsExpanded] = React.useState(false);

  React.useEffect(() => {
    if (setChildMinimize) setChildMinimize(() => setIsExpanded((p) => !p));
    if (setChildSettings) setChildSettings(() => setSettings((p) => ({ ...p, isToggle: !p.isToggle })));
  }, [setChildMinimize, setChildSettings]);

  const handleChangeInput = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    keyRef?: string
  ) => keyRef && updateNodeValue(id, setNodes, { [keyRef]: e.target.value });


  const isWarning = !data.value?.connection || !data.value?.messageText;

  return (
    <>
      <SettingsBlock nodeId={id} data={settings} setData={setSettings} />
      <Main>
        {isWarning ? <>
          <div id="warning"></div>
          <span id="warningIcon"><IoWarningOutline size={ 21 } /></span>
        </> : data.output ? <>
          <div id="ran"></div>
          <span id="ranIcon"><IoCheckmarkCircleOutline size={ 21 } /></span>
        </> : null}
        {isExpanded && (
          <ExpandedBlock
            data={{ id, ...data }}
            handleClose={() => setIsExpanded(false)}
            style={{ minWidth: "420px" }}
            isWarning={isWarning}
          >
       
            <Styled>

              <AuthenticateSelect
                type="instagramMsgs"
                defaultId={data.value?.connection?._id || data.value?.connection?.id || data.value?.connectionId}
                handleAuthenticate={(type, connection) => {
                  if (type === "add") {
                    const connectionId = connection._id || connection.id;
                    updateNodeValue(id, setNodes, { connection, connectionId });
                  } else {
                    updateNodeValue(id, setNodes, { connection: null, connectionId: null });
                  }
                }}
                withLine={!data.value?.connection}
                background={data.background}
              />

              <div style={{ marginBottom: "10px" }}>
                <TextInput
                  keyRef="recipientId"
                  value={data.value?.recipientId || ""}
                  title="Recipient Id"
                  placeholder="User Id or Conversation Id"
                  handleChange={handleChangeInput}
                />
              </div>

              <Textarea
                keyRef="messageText"
                value={data.value?.messageText || ""}
                placeholder="Type your Instagram message or use variables like {{ $block.listener.output }}"
                handleChange={handleChangeInput}
              />
            </Styled>
          </ExpandedBlock>
        )}
      </Main>
    </>
  );
}